{
  "pageTitle": "أحدث الأخبار",
  "title1": "آخر التحديثات عن",
  "title2": "مدرسة منارة",
  "subtitle": "تعرف على المزيد إنجازات طلاب منارة وفريق العمل والخريجين، داخل وخارج الفصل الدراسي، وفي جميع أنحاء العالم.",
  "loadMore": "أظهر المزيد من الأخبار",
  "articlesError": "فشل في الحصول على بيانات أخبار مدرسة منارة"
}
